"use client";

import { PWADownloadToast } from "./PWADownloadToast";

export function PWAInstallPrompt() {
  return (
    <PWADownloadToast
      position="top-right"
      autoShow={true}
      delay={3000}
    />
  );
}
